function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module table/commands/insertcolumncommand
 */
import Command from '@ckeditor/ckeditor5-core/src/command';
import { findAncestor } from './utils';
/**
 * The insert column command.
 *
 * The command is registered by {@link module:table/tableediting~TableEditing} as the `'insertTableColumnLeft'` and
 * `'insertTableColumnRight'` editor commands.
 *
 * To insert a column to the left of the selected cell, execute the following command:
 *
 *		editor.execute( 'insertTableColumnLeft' );
 *
 * To insert a column to the right of the selected cell, execute the following command:
 *
 *		editor.execute( 'insertTableColumnRight' );
 *
 * @extends module:core/command~Command
 */

var InsertColumnCommand =
/*#__PURE__*/
function (_Command) {
  _inherits(InsertColumnCommand, _Command);

  /**
   * Creates a new `InsertColumnCommand` instance.
   *
   * @param {module:core/editor/editor~Editor} editor An editor on which this command will be used.
   * @param {Object} options
   * @param {String} [options.order="right"] The order of insertion relative to the column in which the caret is located.
   * Possible values: `"left"` and `"right"`.
   */
  function InsertColumnCommand(editor) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, InsertColumnCommand);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InsertColumnCommand).call(this, editor));
    /**
     * The order of insertion relative to the column in which the caret is located.
     *
     * @readonly
     * @member {String} module:table/commands/insertcolumncommand~InsertColumnCommand#order
     */

    _this.order = options.order || 'right';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(InsertColumnCommand, [{
    key: "refresh",
    value: function refresh() {
      var selection = this.editor.model.document.selection;
      var tableParent = findAncestor('table', selection.getFirstPosition());
      this.isEnabled = !!tableParent;
    }
    /**
     * Executes the command.
     *
     * Depending on the command's {@link #order} value, it inserts a column to the `'left'` or `'right'` of the column
     * in which the selection is set.
     *
     * @fires execute
     */

  }, {
    key: "execute",
    value: function execute() {
      var editor = this.editor;
      var selection = editor.model.document.selection;
      var tableUtils = editor.plugins.get('TableUtils');
      var insertBefore = this.order === 'left';
      var referencePosition = insertBefore ? selection.getFirstPosition() : selection.getLastPosition();
      var referenceRange = insertBefore ? selection.getFirstRange() : selection.getLastRange();
      var tableCell = referenceRange.getContainedElement() || findAncestor('tableCell', referencePosition);
      var table = tableCell.parent.parent;

      var _tableUtils$getCellLo = tableUtils.getCellLocation(tableCell),
          column = _tableUtils$getCellLo.column;

      tableUtils.insertColumns(table, {
        columns: 1,
        at: insertBefore ? column : column + 1
      });
    }
  }]);

  return InsertColumnCommand;
}(Command);

export { InsertColumnCommand as default };